import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import { CheckboxGroup } from '@/containers/SubscriptionFormPageNew/Components/ModalSaveAndSend/styled-components'
import useContact from '@/containers/SubscriptionFormPageNew/Components/Contact/useContact'
import useSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/useSaveButtons'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import LanguagePicker from '@/containers/SubscriptionFormPageNew/Components/AdditionalSales/bones/LanguagePicker'
import useReviewLanguage from '@/containers/SubscriptionFormPageNew/Components/Contact/useReviewLanguage'

const ModalReviewEmail = ({ hidden }) => {
  const { t, isEditable } = useSaveButtons({ setIsOpen: null })

  const { isReviewRegistered, createReviewsInteraction } = useContact()
  const {
    country,
    reviewLanguage,
    reviewLanguageOptions,
    selectedLanguageLabel,
    isReviewLanguageRequired,
    setReviewLanguage,
    setReviewRequested,
  } = useReviewLanguage()

  if (hidden) return null

  const checked = isReviewRegistered || !!createReviewsInteraction

  return (
    <ModalSection>
      <CheckboxGroup>
        <SDCheckbox
          disabled={isReviewRegistered || !isEditable}
          checked={checked}
          onChange={setReviewRequested}
          labelPlacement={LABEL_PLACEMENT.right}
          label={t('subscriptionForm:header.modal_save_send.reviews_mail_text')}
        />
        <LanguagePicker
          hidden={!checked || !isReviewLanguageRequired}
          country={country}
          currentLanguage={reviewLanguage}
          disabled={isReviewRegistered || !isEditable}
          onClickHandler={setReviewLanguage}
          languages={reviewLanguageOptions}
        />
        <SDNotification
          type='info'
          hidden={!checked || !isReviewLanguageRequired || !selectedLanguageLabel}
          primaryText={t('subscriptionForm:header.modal_save_send.review_language_selected', {
            language: selectedLanguageLabel,
          })}
        />
        <SDNotification
          type='info'
          hidden={!isReviewRegistered}
          primaryText={t('subscriptionForm:header.modal_save_send.reviews_already_registered')}
        />
      </CheckboxGroup>
    </ModalSection>
  )
}

export default ModalReviewEmail
